import { ResourceLanguage } from 'i18next'

import translation from './translation.json'

const en: ResourceLanguage = {
  translation
}

export default en
